package com.hyperether.goodjob.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Step(
    @SerialName("stepTitle") var stepTitle: String? = null,
    @SerialName("stepDescription") var stepDescription: String? = null,
    @SerialName("estimatedDuration") var estimatedDuration: Int? = null,
    @SerialName("stepStatus") var stepStatus: String? = null
) {
    fun isDifferent(other: Step): Boolean {
        val differences = mutableListOf<String>()

        if (this.stepTitle != other.stepTitle) differences.add("stepTitle: '${this.stepTitle}' vs '${other.stepTitle}'")
        if (this.stepDescription != other.stepDescription) differences.add("stepDescription: '${this.stepDescription}' vs '${other.stepDescription}'")
        if (this.estimatedDuration != other.estimatedDuration) differences.add("estimatedDuration: '${this.estimatedDuration}' vs '${other.estimatedDuration}'")
        if (this.stepStatus != other.stepStatus) differences.add("stepStatus: '${this.stepStatus}' vs '${other.stepStatus}'")

        if (differences.isNotEmpty()) {
            println("Step differences found for step '${this.stepTitle}':")
            differences.forEach { println("  - $it") }
            return true
        }

        return false
    }
}
